<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/user/index">我的账户</a><span class="space">/</span>协议账单
				</div>
				<cnPubtips></cnPubtips>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="error_box" v-if="errStatus">
				<h3>{{errMessage}}</h3>
			</div>
			<div class="order_title" v-if="!errStatus">账单编号：{{orderDetail.OrderNo}}</div>
			<div class="order_main_box" v-if="!errStatus">
				<div class="omb_left">
					<div class="ol_item">
						<h3>账单详情</h3>
						<div class="oll_box">
							<ul>
								<li>
									<div class="title">商品名称：</div>
									<div class="content">{{orderDetail.Title}}</div>
								</li>
								<li>
									<div class="title">下单时间：</div>
									<div class="content">{{orderDetail.Time}}</div>
								</li>
								<li>
									<div class="title">客人信息：</div>
									<div class="content">{{orderDetail.PersonTxt}}</div>
								</li>
								<li>
									<div class="title">酒店信息：</div>
									<div class="content">{{orderDetail.HotelTxt}}</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="ol_item">
						<h3>行程信息</h3>
						<div class="oll_box">
							<ul>
								<li>
									<div class="title">行程时间：</div>
									<div class="content">{{orderDetail.TravelDate}}</div>
								</li>
								<li>
									<div class="title">行程内容：</div>
									<div class="content" v-html="orderDetail.TravelInformation"></div>
								</li>
							</ul>
						</div>
					</div>
					<div class="ol_item" style="margin-top: 40px;">
						<h3>联系人信息</h3>
						<div class="oll_box">
							<ul>
								<li>
									<div class="title">姓名：</div>
									<div class="content">{{orderDetail.LinkMan}}</div>
								</li>
								<li>
									<div class="title">手机：</div>
									<div class="content">{{orderDetail.Mobile}}</div>
								</li>
								<li>
									<div class="title">邮箱：</div>
									<div class="content">{{orderDetail.Email}}</div>
								</li>
							</ul>
						</div>
					</div>					
					<div class="ol_item" style="border: 0; padding-bottom: 20px;">
						<h3>付款信息</h3>
						<div class="oll_box">
							<ul>
								<li>
									<div class="title">金额：</div>
									<div class="content">${{orderDetail.TotalPrice}}</div>
								</li>
								<li>
									<div class="title">账单状态：</div>
									<div class="content">{{orderDetail.StatusTxt}}</div>
								</li>
							</ul>
							<div class="payment_list">
								<ul class="head">
									<li style="width: 12%;">类型</li>
									<li style="width: 12%;">金额</li>
									<li style="width: 12%;">支付状态</li>
									<li style="width: 12%;">实付金额</li>
									<li style="width: 20%;">付款时间</li>
									<li style="width: 32%;">付款凭证流水号</li>
								</ul>
								<ul class="body" v-for="(item, index) in orderDetail.PaymentRecords" :key="index">
									<li style="width: 12%;">{{item.Reason}}</li>
									<li style="width: 12%;">${{item.PayablePrice}}</li>
									<li style="width: 12%;">{{item.Status}}</li>
									<li style="width: 12%;">{{item.ActualPayPrice !='0.00' ? item.ActualPayPrice : ''}}</li>
									<li style="width: 20%;">{{item.ActualPayTime !='' ? ActualPayTime : ''}}</li>
									<li style="width: 32%;">{{item.VoucherNumber !='' ? item.VoucherNumber : ''}}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				
				<div class="omb_right">
					<div class="price_box">
						<div class="price">${{priceValue}}</div>
						<div class="status" v-if="priceType !=''">{{priceType}}</div>
						<div class="tips" v-if="orderDetail.OpRemark !=''">{{orderDetail.OpRemark}}</div>
						<div class="pay_box">
							<div class="button_box" v-if="orderDetail.Status==1 || orderDetail.Status==2 || orderDetail.Status==4">
								<el-button type="primary" round :loading="btnLoading" @click="payHandle()">{{btnTxt}}</el-button>
								<div v-html="orderDetail.AuthorizeNetForm"></div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		checkToken,
		getProtocolDetail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnPubtips from '@/components/cn_pubtips.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_UserProtocolDetail',
		mixins: [mixin],
		components: {
			cnHeader,
			cnPubtips,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				errStatus: false,
				errMessage: '错误：非正常加载页面',
				
				orderDetail:[],
				
				btnLoading: false,
				btnTxt: '立即支付',
				priceType: '',
				priceValue: '',
			}
		},
		created() {			
			// 获取orderNo
			if (this.$route.query.OrderNo != undefined && this.$route.query.OrderNo !='') {
				this.orderNo = this.$route.query.OrderNo
			}
			else
			{
				this.errStatus = true
				this.errMessage = '错误：账单号不能为空'
			}
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/cn/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
					})
				}
			},
			//获取数据
			async getData() {
				const { data: res } = await getProtocolDetail(this.language, this.token, this.terminal, this.orderNo)				
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.orderDetail = res.data
					
					if(this.orderDetail.Status == 1)
					{
						this.priceType = '账单全款'
						this.priceValue = this.orderDetail.TotalPrice
					}
					else if(this.orderDetail.Status == 2)
					{
						this.priceType = '账单定金'
						this.priceValue = this.orderDetail.Deposit
					}
					else if(this.orderDetail.Status == 4)
					{
						this.priceType = '账单尾款'
						this.priceValue = this.orderDetail.BalancePayment
					}
					
					console.log(this.orderDetail.Status)
				} else {
					this.errStatus = true
					this.errMessage = '错误：'+res.errmsg
				}
			},
			//立即支付
			payHandle()
			{
				if(this.btnLoading)
				{
					return
				}
				
				this.btnLoading = true
				this.btnTxt = "请求支付中，请稍侯..."
				
				const form = document.getElementById('visa_post_form');
				if (form) {
					form.submit(); // 提交表单
				} else {
					this.$message.error("支付请求失败，请稍侯再试！");
				}
				this.btnLoading = true
				this.btnTxt = "立即支付"
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.error_box {
			min-height: 700px;
			text-align: center;
			box-sizing: border-box;
			padding-top: 300px;
			
			h3 {
				font-size: 28px;
			}
		}
		
		.order_title {
			margin-top: 20px;
			line-height: 140%;
			font-size: 28px;
			font-weight: 500;
		}
		
		.order_main_box {
			min-height: 700px;
			margin-top: 24px;
			margin-bottom: 80px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			border: #016750 solid 2px;
			border-radius: 8px;
			box-sizing: border-box;
			background-color: #fff;
			background-position: 900px 100%;
			background-repeat: repeat-y;
			background-image: url(@/assets/images/icons/shu_line.png);
			padding: 30px;
			box-shadow: 0 10px 20px #ddd;
			
			.omb_left {
				width: 830px;
				box-sizing: border-box;
				padding-bottom: 10px;
				
				
				.ol_item {
					margin-top: 40px;
					border-bottom: #e4e4e4 dotted 1px;
					padding-bottom: 40px;
					
					h3 {
						font-size: 18px;
					}
					
					.oll_box {
						margin-top: 24px;
						
						ul {							
							li {
								display: flex;
								margin-top: 10px;
								font-size: 14px;
								
								.title {
									width: 11%;
									box-sizing: border-box;
									text-align: right;
									padding-right: 8px;
									color: #666;
								}
								.content {
									width: 89%;
									
									.room_box {
										display: flex;
										flex-wrap: wrap;
										
										.room {
											width: 48%;
											box-sizing: border-box;
											margin: 0 14px 15px 0;
											padding: 12px;
											background-color: #f9f9f9;
											border-radius: 8px;
											
											h3 {
												font-size: 15px;
												font-weight: 500;
											}
											p {
												margin-top: 8px;
											}
										}
									}
								}
							}
						}
					}
				}
				.ol_item:first-child {
					margin-top: 0;
				}
				
				.payment_list {
					padding: 20px 0 0 90px;
					ul,li {
						clear: both;
					}
					ul.head {
						width: 100%;
						display: flex;
						background: #f7f7f7;
						li {
							font-weight: 500;
							margin: 0;
							padding: 10px 12px;
							font-size: 12px;
							box-sizing: border-box;
							text-align: left;
						}
					}
					ul.body {
						width: 100%;
						display: flex;
						border-bottom: #e4e4e4 solid 1px;
						li {
							margin: 0;
							padding: 10px 12px;
							font-size: 12px;
							box-sizing: border-box;
							text-align: left;
						}
					}
				}
			}
			
			.omb_right {
				width: 360px;
				box-sizing: border-box;
				padding-right: 10px;
				padding-bottom: 10px;
				
				.price_box {
					text-align: right;
				
					.price {
						margin-top: 10px;
						font-size: 28px;
						font-weight: 500;
					}
					.ext_price {
						margin-top: 6px;
						font-size: 14px;
						color: #888;
						font-style: italic;
					}
					
					.status {
						margin-top: 10px;
						font-size: 13px;
						font-style: italic;
					}
					
					.tips {
						margin-top: 10px;
						display: inline-block;
						height: 26px;
						line-height: 26px;
						border-radius: 13px;
						font-size: 12px;
						color: #ff6600;
						background-color: #FFEFE0;
						background-image: url(@/assets/images/icons/d_tip.png);
						background-repeat: no-repeat;
						background-position: 12px center;
						background-size: 13px 12px;
						padding: 0 10px 0 30px;
					}
					
					.pay_box {
						width: 100%;
						margin-top: 60px;
						
						.button_box {
							margin-top: 30px;
						}
					}
				}
			}
		}
		
		.el-button {
			width: 100%;
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border-radius: 21px;
			-webkit-transition: all .3s ease;
		}
		.el-button--default {
			border: #666 solid 1px;
			color: #666;
			margin-left: 20px;
		}
		.el-button--default:hover {
			border: #008768 solid 1px;
			color: #008768;
		}
		.el-button.is-plain:focus  {
			border: #008768 solid 1px;
			color: #008768;
		}
		
		.el-button--primary {
			border: 0;
		}		
		.el-button--primary:focus {
			background-color: #008768;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
	}
</style>